import { Component } from '@theme/component';

export const electionHomePhase = (now = Date.now()) => now < Date.parse('2026-10-23T23:00:00Z') ? 'before' : now < Date.parse('2026-11-03T10:00:00Z') ? 'open' : now < Date.parse('2026-11-03T10:30:00Z') ? 'closed' : 'results';

class ElectionHome extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.labels = JSON.parse(this.querySelector('[data-election-labels]').textContent);
    this.loading = false;
    this.controller = new AbortController();
    this.addEventListener('election:polls-closed', () => this.updatePhase(), {signal: this.controller.signal});
    this.updatePhase();
    this.timer = setInterval(() => this.updatePhase(), 15000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) this.updatePhase(); }, {signal: this.controller.signal});
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.timer);
    this.controller?.abort();
    this.request?.abort();
  }
  updatePhase() {
    const phase = electionHomePhase(), changed = this.dataset.phase !== phase;
    this.dataset.phase = phase;
    const verifying = phase === 'results' && Date.now() >= Date.parse('2026-11-03T13:30:00Z') && Date.now() < Date.parse('2026-11-03T13:50:00Z');
    this.querySelector('[data-election-title]').textContent = phase === 'results' && this.certified ? this.labels.certified : verifying ? this.labels.verification_title : this.labels[phase + '_title'];
    this.querySelector('[data-election-copy]').textContent = phase === 'results' && this.certified ? this.labels.certified_copy : verifying ? this.labels.verification_copy : this.labels[phase + '_copy'];
    const deadline = this.querySelector('[data-election-deadline]');
    if (deadline) deadline.textContent = this.labels[phase === 'open' || phase === 'before' ? 'deadline' : 'coverage_schedule'];
    const link = this.querySelector('[data-election-link]');
    link.replaceChildren(document.createTextNode(this.labels[phase + '_action'] + ' ↗'));
    link.href = phase === 'open' ? 'https://gov.floptropica.com/' : phase === 'before' ? 'https://gov.floptropica.com/' : 'https://gov.floptropica.com/#results';
    if (phase !== 'results') this.querySelector('[data-election-status]').textContent = this.labels[phase + '_title'].replace(/\.$/, '') + ' · UTC+8';
    else if (!document.hidden && !this.loading && (changed || !this.nextFetch || Date.now() >= this.nextFetch)) void this.loadReturns();
  }
  async loadReturns() {
    this.loading = true;
    const request = new AbortController();
    this.request = request;
    const timeout = setTimeout(() => request.abort(), 10000);
    const status = this.querySelector('[data-election-status]');
    if (!this.lastSuccess) status.textContent = this.labels.connecting;
    try {
      const response = await fetch(this.dataset.api + '/api/v1/results', {cache: 'no-store', headers: {Accept: 'application/json'}, signal: request.signal});
      if (!response.ok) throw new Error('Returns unavailable');
      const data = await response.json();
      if (!this.isConnected || this.request !== request) return;
      const progress = data.returns;
      if (progress && Number.isFinite(data.ballotCount) && Number.isFinite(progress.percentReleased)) {
        this.querySelector('[data-election-returns]').hidden = false;
        this.querySelector('[data-election-ballots]').textContent = data.ballotCount.toLocaleString();
        this.querySelector('[data-election-percent]').textContent = progress.percentReleased.toLocaleString() + '%';
        this.querySelector('[data-election-progress]').value = progress.percentReleased;
      } else {
        // An official publication may omit website-release metrics. Do not keep
        // a stale partial percentage beside a certified result.
        this.querySelector('[data-election-returns]').hidden = true;
      }
      this.certified = data.certified === true;
      this.lastSuccess = Date.now();
      const verifying = Date.now() >= Date.parse('2026-11-03T13:30:00Z') && Date.now() < Date.parse('2026-11-03T13:50:00Z');
      this.querySelector('[data-election-title]').textContent = data.certified ? this.labels.certified : verifying ? this.labels.verification_title : this.labels.results_title;
      this.querySelector('[data-election-copy]').textContent = data.certified ? this.labels.certified_copy : verifying ? this.labels.verification_copy : this.labels.results_copy;
      status.textContent = (data.certified ? this.labels.certified : verifying ? this.labels.verification_status : this.labels.provisional) + ' · ' + this.labels.updated + ' ' + new Date(this.lastSuccess).toLocaleTimeString([], {timeZone: 'Asia/Singapore', hour: '2-digit', minute: '2-digit', hour12: false}) + ' (UTC+8)';
      this.nextFetch = Date.now() + 30000;
    } catch {
      if (this.isConnected && this.request === request) status.textContent = this.labels.unavailable;
      this.nextFetch = Date.now() + 60000;
    } finally {
      clearTimeout(timeout);
      if (this.request === request) this.loading = false;
    }
  }
}
if (!customElements.get('fnec-home')) customElements.define('fnec-home', ElectionHome);
